import {Component} from "react";
import {RouteComponentProps, withRouter} from "react-router";

class ScrollToTop extends Component<RouteComponentProps<{}, {}, {}>, {}> {
    public componentDidUpdate(prevProps: any) {
        if (this.props.location.pathname !== prevProps.location.pathname && this.props.location.hash === "") {
            window.scrollTo(0, 0);
        }
    }

    public render() {
        return this.props.children;
    }
}

export default withRouter(ScrollToTop);


// WEBPACK FOOTER //
// ./src/utils/ScrollToTop.tsx